module.exports = __webpack_public_path__ + "img/img-136.8897d2d8.png";